import axios from 'axios'
const baseURL = '/api/competences'
export default class Competence {
	/** @constructor
	 * @param {number | Object} init
	 */
	constructor (init = {}) {
		this.id = init.hasOwnProperty('id') ? init.id : null
		this.answer_id = init.hasOwnProperty('answer_id') ? init.answer_id : null
		this.rating = init.hasOwnProperty('rating') ? init.rating : null
		this.name = init.hasOwnProperty('name') ? init.name : ''
		this.status = init.hasOwnProperty('status') ? init.status : false
	}

	static url = baseURL

	static createObjectFromArray (arr) {
		if (!arr || !Array.isArray(arr)) return []

		return arr.map(item => new Competence(item))
	}
	/**
	 * get all competences
	 * @param {Object} params
	 * @returns {Promise<{data: Competence[]}>}
	 */
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: this.createObjectFromArray(res.data.data)
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	get formDataInAnswer () {
		const formData = new FormData()

		formData.append(`competence[${this.id}][answer_id]`, this.answer_id)
		formData.append(`competence[${this.id}][status]`, this.status ? 1 : 0) // todo поменять на true/false (backend)

		return formData
	}

	updateInAnswer (testId) {
		return axios.post(`/api/test/${testId}/competence`, this.formDataInAnswer)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Test/Competence.class.js